// Helpful functions for randomization of songs.
// Don't use these for security purposes.
// Not important for this to be secure.
// Returns true with given probability
export function RandProb(probability: number): boolean {
  return Math.random() < probability
}

// Uses the rand value at the given index. Not inclusive of end.
export function RandRange(start: number, end: number, whole: boolean = true): number {
  let guess = Math.random() * (end - start) + start
  if (whole) {
    return Math.floor(guess)
  }
  return guess
}

// Gets a random index in the given array
export function RandIndex(array: Array<any>) {
  if (!array) throw "Array is undefined, can't get random index."
  if (array.length === 0) throw "Array length is 0, can't get random index."
  return Math.floor(Math.random() * array.length)
}

export function RandIndexWithDistributions(distributions: number[]) {
  if (!distributions) throw "Array is undefined, can't get random index."
  if (distributions.length === 0) throw "Distributions array length is 0, can't get random index."
  var distrosum = 0
  for (var i = 0; i < distributions.length; i++) {
    distrosum += distributions[i]
  }

  // [0.1, 0.5, 0.3] ->
  // anything less than 0.1 should return 0, less than 0.6 should return 1, etc

  var currentSum = 0
  var randomval = RandRange(0, distrosum, false)
  for (var i = 0; i < distributions.length; i++) {
    currentSum += distributions[i]
    if (currentSum >= randomval) {
      return i
    }
  }
  throw Error('problem with randindexwithdistributions')
}
